import React from 'react'
import Modal from '../../../../components/Modal'
import * as S from './ModalChangeDockStatus.styles'
import Form from 'src/components/FormComponents/Form'
import { ButtonMui } from 'src/components/ButtonMui/ButtonMui'

interface ModalChangeDockStatusProps {
  confirmAction: (event?: React.FormEvent<HTMLFormElement>) => void
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  isOpen: boolean
  dockCode: string
}

const ModalChangeDockStatus = ({
  confirmAction,
  setIsOpen,
  isOpen,
  dockCode,
}: ModalChangeDockStatusProps) => {
  const onSubmit = React.useCallback(
    () => {
      confirmAction()
      setIsOpen(false)
    },
    [confirmAction, setIsOpen],
  )

  const cancelModal = () => {
    setIsOpen(false)
  }

  return (
    <Modal
      testId='modal-change-dock-status'
      show={isOpen}
      closedButton={false}
      title='ALTERAR STATUS'
      titleStyle={{ fontSize: '16px', letterSpacing: '1.5px' }}
      IconLeft={() => <S.EditIcon />}
      body={(
        <S.BodyModal>
          <S.Form as={Form} onSubmit={undefined}>
            <S.InfoContainer>
              <S.ModalMessage>
                Confirmar a alteração da doca {dockCode} para LIVRE?
              </S.ModalMessage>
            </S.InfoContainer>
            <S.ContainerButton>
              <ButtonMui
                title='Confirmar'
                onClick={onSubmit}
                testId='button-confirm'
                bgColor='blue'
                hoverColor='darkBlueHover'
                letterColor='white'
              />
              <ButtonMui
                title='Cancelar'
                onClick={cancelModal}
                testId='button-cancel'
                bgColor='red'
                hoverColor='redHover'
                letterColor='white'
              />
            </S.ContainerButton>
          </S.Form>
        </S.BodyModal>
      )}
    />
  )
}

export default ModalChangeDockStatus
